var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"downloadingBar"}},[_c('button',{attrs:{"id":"downloadingButton"}},[_c('a',{attrs:{"href":_vm.dwnUrl,"rel":"nofollow"}},[_vm._v("Скачать")])])])}
var staticRenderFns = []

export { render, staticRenderFns }